// Central handling of session expiry for the backoffice domain (session-only
// auth: Symfony returns 401 when the session is gone). Auth endpoints keep
// their inline error handling and are never redirected.
export const BO_AUTH_EXPIRED_STORAGE_KEY = 'boSessionExpired';

const REDIRECT_GUARD_STORAGE_KEY = 'boSessionExpiredRedirectAt';
const REDIRECT_LOOP_WINDOW_MS = 5000;
const SKIPPED_URL_PREFIXES = ['/api/v2/backoffice/login', '/api/v2/backoffice/auth/', '/api/v2/backoffice/password/'];

let redirectInFlight = false;

/**
 * Redirects to the backoffice login route when the given API error means the
 * session expired. Returns true when the redirect was triggered (callers must
 * then swallow the error so nothing surfaces while the page unloads).
 */
export function handleBoAuthExpiry(error, url) {
    if (error?.status !== 401) {
        return false;
    }
    if (SKIPPED_URL_PREFIXES.some((prefix) => url.startsWith(prefix))) {
        return false;
    }
    if (window.location.pathname.endsWith('/login')) {
        return false;
    }
    if (redirectInFlight) {
        return true;
    }

    // Loop breaker: never bounce twice within the window (guard key is never consumed by views).
    const lastRedirectAt = Number(sessionStorage.getItem(REDIRECT_GUARD_STORAGE_KEY));
    if (lastRedirectAt && Date.now() - lastRedirectAt < REDIRECT_LOOP_WINDOW_MS) {
        return false;
    }

    redirectInFlight = true;
    error.authExpired = true;
    sessionStorage.setItem(REDIRECT_GUARD_STORAGE_KEY, String(Date.now()));
    sessionStorage.setItem(BO_AUTH_EXPIRED_STORAGE_KEY, String(Date.now()));
    window.location.assign(`${import.meta.env.BASE_URL}login`);
    return true;
}
